import React, { useState } from "react";
import api from "@/lib/api";

const OPTIONS = [
    { value: "great", emoji: "😍" },
    { value: "good", emoji: "🙂" },
    { value: "meh", emoji: "😐" },
    { value: "bad", emoji: "😞" },
];

const STORAGE_KEY = "vd_feedback_voted_at";

export default function FeedbackBanner() {
    const already = (() => {
        try {
            const at = localStorage.getItem(STORAGE_KEY);
            return at && Date.now() - Number(at) < 30 * 24 * 60 * 60 * 1000;
        } catch { return false; }
    })();
    const [dismissed, setDismissed] = useState(already);
    const [voted, setVoted] = useState(null);
    const [busy, setBusy] = useState(false);

    const vote = async (value) => {
        if (busy) return;
        setBusy(true);
        try {
            await api.post("/feedback/vote", { value });
            setVoted(value);
            try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch { /* noop */ }
            setTimeout(() => setDismissed(true), 1800);
        } catch { /* noop */ }
        finally { setBusy(false); }
    };

    if (dismissed) return null;

    return (
        <div data-testid="feedback-banner" className="feature-card-neu w-full px-5 py-4 flex items-center justify-between flex-wrap gap-3 my-6">
            {voted ? (
                <span className="text-sm text-ink-100">Grazie per il tuo feedback! {OPTIONS.find((o) => o.value === voted)?.emoji}</span>
            ) : (
                <>
                    <span className="text-sm text-ink-100">La tua opinione è fondamentale: come ti senti oggi su vendidirect.it?</span>
                    <div className="flex items-center gap-2">
                        {OPTIONS.map((o) => (
                            <button
                                key={o.value}
                                data-testid={`feedback-emoji-${o.value}`}
                                onClick={() => vote(o.value)}
                                disabled={busy}
                                className="feature-toggle-btn w-10 h-10 flex items-center justify-center text-xl disabled:opacity-40"
                                title={o.value}
                            >
                                {o.emoji}
                            </button>
                        ))}
                    </div>
                </>
            )}
            <button data-testid="feedback-banner-dismiss" onClick={() => { setDismissed(true); try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch { /* noop */ } }} className="text-ink-500 hover:text-ink-100 text-xs">✕</button>
        </div>
    );
}
